import React, { useState } from 'react';
import { Button } from '../../../components/common';
import StudentCard from './StudentCard';
import StudentListHeader from './StudentListHeader';

const StudentListPanel = ({
  isStudentSelected,
  selectedStudent,
  studentsData,
  totalItems,
  filters,
  isLoading,
  isLoadingMore,
  hasMore,
  onStudentSelect,
  onSelectedStudentChange, // 상태 업데이트용 추가
  onStudentDetailClick,
  onSelectedStudentCardClick,
  onFilterChange,
  onFilterKeyPress,
  onSearch,
  onReset,
  onScroll,
  studentListRef,
  isMobile = false,
  userType = null,
  // Teacher 데이터 props 추가
  teachers = [],
  isTeachersLoading = false
}) => {
  const [selectedHotkey, setSelectedHotkey] = useState(null);
  const [shouldAutoSearch, setShouldAutoSearch] = useState(false);

  // Teacher 데이터는 useStudents 훅에서 통합 관리되므로 여기서는 제거

  // 핫키 관련 로직 - 메모이제이션으로 리렌더링 최적화
  const handleHotkeySelect = React.useCallback((hotkeyId, forceSearch = false) => {
    setSelectedHotkey(hotkeyId);
    
    if (hotkeyId) {
      const hotkeyMap = {
        'elementary_school': '초등학교',
        'middle_school': '중학교',
        'high_school': '고등학교'
      };
      
      // 학교 이름 필터에 핫키 값 설정하고 자동 검색 플래그 설정
      setShouldAutoSearch(true);
      onFilterChange({ target: { name: 'school_name', value: hotkeyMap[hotkeyId] } });
    } else {
      // 핫키 비활성화 시 학교 이름 필터 클리어
      if (forceSearch) {
        setShouldAutoSearch(true);
      }
      onFilterChange({ target: { name: 'school_name', value: '' } });
    }
  }, [onFilterChange]);

  // 학교 이름 필터가 변경되면 핫키 상태도 업데이트
  React.useEffect(() => {
    if (!filters.school_name) {
      setSelectedHotkey(null);
    } else {
      const reverseHotkeyMap = {
        '초등학교': 'elementary_school',
        '중학교': 'middle_school',
        '고등학교': 'high_school'
      };
      const matchedHotkey = reverseHotkeyMap[filters.school_name];
      if (matchedHotkey !== selectedHotkey) {
        setSelectedHotkey(matchedHotkey || null);
      }
    }
  }, [filters.school_name]);

  // 핫키로 필터 변경 시 자동 검색
  React.useEffect(() => {
    if (shouldAutoSearch) {
      setShouldAutoSearch(false);
      onSearch();
    }
  }, [filters.school_name, shouldAutoSearch, onSearch]);
  return (
    <div 
      className={`flex flex-col overflow-hidden rounded-3xl bg-white shadow-lg ${isMobile ? 'h-full' : ''}`}
      style={isMobile ? { 
        width: 'calc(100% - 28.8px)', 
        height: 'calc(100% - 28.8px)',
        margin: '14.4px 14.4px 14.4px 14.4px'
      } : {}}
    >
      {/* 학생 목록 헤더 영역 */}
      <StudentListHeader
        isStudentSelected={isStudentSelected}
        selectedStudent={selectedStudent}
        studentsDataLength={studentsData?.length}
        totalItems={totalItems}
        filters={filters}
        teachers={teachers}
        isTeachersLoading={isTeachersLoading}
        selectedHotkey={selectedHotkey}
        onStudentDetailClick={onStudentDetailClick}
        onSelectedStudentCardClick={onSelectedStudentCardClick}
        onFilterChange={onFilterChange}
        onFilterKeyPress={onFilterKeyPress}
        onSearch={onSearch}
        onReset={onReset}
        onHotkeySelect={handleHotkeySelect}
        isMobile={isMobile}
        userType={userType}
      />
      
      {/* 학생 목록 영역 */}
      {!isStudentSelected && (
        <div 
          ref={studentListRef}
          className={`min-h-0 flex-1 overflow-y-auto bg-gray-50 shadow-lg ${isMobile ? 'mobile-student-list' : ''}`}
          style={isMobile ? { padding: 0 } : {}}
          onScroll={onScroll}
        >
          <div data-panel="student-list"> 
            {studentsData?.map((student) => (
              <StudentCard
                key={student.student_id}
                student={student}
                isSelected={selectedStudent?.student_id === student.student_id}
                onClick={() => {
                  // 즉시 상태 업데이트 (중복 API 호출 방지)
                  if (onSelectedStudentChange) {
                    onSelectedStudentChange(student);
                  }
                  // URL 변경
                  onStudentSelect(student);
                }}
                onDetailClick={onStudentDetailClick}
              />
            ))}
            
            {/* 로딩 상태 */}
            {isLoadingMore && (
              <div className="flex items-center justify-center py-4">
                <p className="text-xs text-gray-500">더 불러오는 중...</p>
              </div>
            )}
            
            {/* 빈 데이터 상태 */}
            {!isLoading && !isLoadingMore && studentsData.length === 0 && (
              <div className="flex items-center justify-center py-4">
                <p className="text-xs text-gray-500">학생 데이터가 없습니다.</p>
              </div>
            )}
            
            {/* 더 이상 데이터가 없을 때 */}
            {!hasMore && !isLoadingMore && studentsData.length > 0 && (
              <div className="flex items-center justify-center py-4">
                <p className="text-xs text-gray-500">모든 학생을 불러왔습니다.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentListPanel; 